import { render } from "./SMarket.vue?vue&type=template&id=6e79625a"
import script from "./SMarket.vue?vue&type=script&lang=js"
export * from "./SMarket.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__